import AttentionBarPicker from '../Page/AttentionBarPicker';

export default AttentionBarPicker;
